import { UnitStatusSearchForm, UnitStatusSearchResponse } from '@mark43/cad-api';
import { CSSProperties } from 'react';
import { Table, TableContainer, Tbody, Th, Thead, Tr, Checkbox } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { ResultSelectionStore } from '../search-windows/use-observable-search-results-selection-store';
import { UnitStatusSearchResultRow } from './unit-status-search-result-row';

export const UnitStatusSearchResultsTable = observer(function UnitStatusSearchResultsTable({
    unitStatusSearchResponse,
    selection,
    customStyle,
    searchData,
}: Readonly<{
    unitStatusSearchResponse?: UnitStatusSearchResponse;
    selection: ResultSelectionStore;
    customStyle?: CSSProperties;
    searchData?: UnitStatusSearchForm;
}>) {
    const rows = unitStatusSearchResponse?.unitStatusSearchRows ?? [];
    return (
        <TableContainer>
            <Table
                size="md"
                variant="accented"
                width="100%"
                {...(customStyle ? { style: customStyle } : {})}
            >
                <Thead>
                    <Tr>
                        <Th key="select">
                            <Checkbox
                                isChecked={
                                    Object.keys(selection.selectedItems).length === rows.length
                                }
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        selection.selectAllOnPage();
                                    } else {
                                        selection.unselectAll();
                                    }
                                }}
                            />
                        </Th>
                        <Th key="date">Date</Th>
                        <Th key="unit">Unit</Th>
                        <Th key="status">Status</Th>
                        <Th key="event-details">Event Details</Th>
                        <Th key="location">Location</Th>
                        <Th key="row-expander" />
                    </Tr>
                </Thead>
                <Tbody>
                    {rows.map((row) => (
                        <UnitStatusSearchResultRow
                            row={row}
                            selection={selection}
                            key={row.unitStatusRmsEventId}
                            searchData={searchData}
                        />
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
});
